import React from "react";
import { connect } from "react-redux";
import { Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  httpGetLatestThreeNotificationByNotification,
  httpGetLatestThreeNotificationByResource,
  httpGetConfigByType,
  httpDeleteNotificationByIdAndType,
  httpGetShippingLocationDetails,
  httpGetVendorProfileByEmail
} from "../../service/httpClient";
import * as Image from "../../assets/js/image";
import GlobalLinks from "./GlobalLinks";
import * as Constants from "../../constants/Constants";
import AppContext from "../../context/appcontext";
import DownloadRenderer from "../VendorOnboarding/Views/DocumentCenter/DownloadRenderer/DownloadRederer";
import * as RolePermissionConstants from "../../constants/RolePermissionConstants";
import { getUserRolePermission } from "../../utils/rolePermissionAccess";
import { getDisableEnableConfig } from "../VendorOnboarding/OnboardingHelper";
import "./globalhome.css";
import store from "../../redux/store";
import Cookies from "js-cookie";


class GlobalHome extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      userRole: "",
      isShippingLocationExist: false,
      deleteInProgress: false,
      gettingContext: true,
      notificationList: [],
      resourceList: [],
      dvnConfigList: {
        showDVNReport: false,
        dvnLinkDetails: ""
      },
      uiConfigList: [],
      allResource: [
        {
          linkName: "ALL RESOURCES",
          linkTo: "/resource",
        },
      ],
      allNotification: [
        {
          linkName: "ALL NOTIFICATIONS",
          linkTo: "/globalNotifications",
        },
      ],
      myApplication: [
        {
          linkName: "Vendor Onboarding",
          linkTo: "/boarding/vendor/company",
        },
      ],
      routingRequest: [
        {
          linkName: "Routing Request",
          linkTo: "/boarding/routing",
        },
      ],
      sellerHub: [
        {
          linkName: "Seller Hub",
          linkTo: "/sellerreports/reports",
        },
      ],
      documentLibRecentUpdates: [
        {
          linkName: "Most Recent Updated Documents",
          linkTo: "/document-library-recent-updates",
        },
      ]
    };
  }

  componentDidMount() {
    if (this.context && this.context.roles) {
      const role = this.context.roles.roleName;
      if (role) {
        this.setState({ userRole: role, gettingContext: false });
      }
    }

    this.getNotificationList();
    this.getResourceList();
    this.getConfigsByType("UI");
    this.getShippingLocation();
    
    getDisableEnableConfig("sellerCentral", (response) => {
      this.setState({ sellerCentral: response });
    });
  }

  componentDidUpdate(prevProps, prevState) {
    const role = this.context.roles.roleName;
    if (prevState.userRole !== role) {
      this.setState({ userRole: role, gettingContext: false });
    }
  }
  verifyShippingMenuAccess() {
    const status = this.props?.status?.onboardingStatus;
    return status && status === Constants.LIVE;
  }

  getConfigsByType = (type) => {
    httpGetConfigByType(type).then((response) => {
      this.setState({uiConfigList: response.data});
      this.getDVNReportConfig();
    }).catch((error) => {
      console.log(error);
    });
  };

  getNotificationList = () => {
    httpGetLatestThreeNotificationByNotification()
      .then((response) => {
        const { data = [], status } = response || {};
        if (status === 200 && data && data.length > 0) {
          this.setState({ notificationList: data });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getResourceList = () => {
    httpGetLatestThreeNotificationByResource()
      .then((response) => {
        const { data = [], status } = response || {};
        if (status === 200 && data && data.length > 0) {
          this.setState({ resourceList: data });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getShippingLocation = () => {
    httpGetVendorProfileByEmail(Cookies.get("email"))
      .then((res) => {
        const vendorDetail = res.data?.vendorDetail;
        if(vendorDetail?.id){
          httpGetShippingLocationDetails(vendorDetail?.id)
          .then((response) => {
            const { data = [], status } = response || {};
            if (status === 200 && data && data.length > 0) {
              this.setState({ isShippingLocationExist: data?.length > 0 });
            }
          })
          .catch((error) => {
            console.log(error);
          });
        }
      }).catch((err) => console.log(err));
  };

  getDocumentUrl = (notificationDocument) => {
    const documentUrl =
      notificationDocument && notificationDocument.documentUrl ? (
        <div>
          <DownloadRenderer data={notificationDocument} />
          {/* <br />
          <span style={{ overflowWrap: "break-word" }}>
            {notificationDocument.documentName.slice(
              0,
              notificationDocument.documentName.lastIndexOf(".")
            )}
          </span> */}
        </div>
      ) : (
        ""
      );

    return documentUrl;
  };

  getResourceRoutingURL() {
    const configValues = this.props?.configValues || [];
    const configValue = configValues.filter(
      (item) => item.key === "shipping_routing_link"
    );
    if (configValue && configValue.length > 0) {
      return configValue[0].value;
    }
    return "#";
  }

  getVSPRoutingURL() {
    const configValues = this.props?.configValues || [];
    const configValue = configValues.filter(
      (item) => item.key === "vsp_app_link"
    );
    if (configValue && configValue.length > 0) {
      return configValue[0].value;
    }
    return "#";
  }

 getRoutingRequestAccess() {
    return (
      getUserRolePermission(
        RolePermissionConstants.ROUTING_REQUEST_ACCESS,
        RolePermissionConstants.ALL
      ) !== RolePermissionConstants.NONE && this.verifyShippingMenuAccess()
    );
  }

  isMtoUser = () => {
    if (this.context && this.context.roles) {
      return this.context.roles.roleName === Constants.ROLE_MTO_MEMBER;
    }
    return false;
  };

  getDVNReportConfig = () => {
    let dvnConfig = {...this.state.dvnConfigList};
    this.state.uiConfigList.map((config) => {
      if (config.key === "show_dvn_report") {
        dvnConfig.showDVNReport = config.value === 'E' ? true : false;
      } else if (config.key === "dvn_report_link") {
        dvnConfig.dvnLinkDetails = config.value;
      }
    });
    this.setState({dvnConfigList: dvnConfig});
  }

  deleteNotification = (notificationId, notificationType) => {
    this.setState({deleteInProgress: true});
    httpDeleteNotificationByIdAndType(notificationId, notificationType)
      .then((response) => {
        const { data = [], status } = response || {};
        if (status === 200 && data) {
          this.setState({ notificationList: data, deleteInProgress: false });
        }
      })
      .catch((error) => {
      	this.setState({deleteInProgress: false});
        console.log(error);
      });
  };

  render() {
    const { showDVNReport, dvnLinkDetails } = this.state.dvnConfigList;
    const routingRequestPermission = this.getRoutingRequestAccess();
    let routingUrl = "#";
    let vspAppLink = this.getVSPRoutingURL();
    let updateRoutingURL = this.state.routingRequest;
    if (routingRequestPermission) {
      routingUrl = this.getResourceRoutingURL();
      updateRoutingURL[0].linkTo = routingUrl;
    }
    if (!this.state.gettingContext) {
      return (
        <Row className="globalHome" md={12}>
          <Col md={6} className="bg-light-withrightborder notificationContainer">
            <Row className="notificationHeader titleStyle">
              <Col md={4}>{Constants.NOTIFICATIONS}</Col>
            </Row>
            <Row className="notificationList">
              {this.state.notificationList && this.state.notificationList.map((value) => {
                return (
                  <Col md={12} className="notificationsType">
                    <p className="notificationSubType1">{value.createdDate}</p>
                    <p className="notificationSubType2">{value.notificationMessage}</p>
                    <p className="notificationSubType3">
                      {this.getDocumentUrl(value)}
                      
                    </p>
                    {getUserRolePermission(
                      RolePermissionConstants.VENDORPLATFORM_MACYHOME_PUBLISH_NOTIFICATIONS,
                      RolePermissionConstants.ALL
                    ) === RolePermissionConstants.EDIT ? (!this.state.deleteInProgress ?
                      <p className="notificationSubTypeDelete" onClick={() => this.deleteNotification(value.notificationId, "notification")}>
                        <Image.DELETE_ICON style="deleteIconNotify"></Image.DELETE_ICON>
                      </p>
                      :
                      <p className="notificationSubTypeDelete">
                        <Image.SPIN_LOADER style="deleteIconNotify"></Image.SPIN_LOADER>
                      </p>)
                      : ""
                    }
                  </Col>
                );
              })}
              <Col md={12} className="notificationsType">
                <p className="notificationSubType1"></p>
                <p className="notificationSubType2">
                  <Link
                    className="linkStyle"
                    style={{
                      textDecoration: "none",
                      color: "#1395c5",
                    }}
                    to={this.state.documentLibRecentUpdates[0]?.linkTo}
                  >
                    {this.state.documentLibRecentUpdates[0]?.linkName}
                  </Link>
                </p>
              </Col>
              {this.state.userRole === Constants.ACCOUNTS_PAYABLE_ADMIN &&
                showDVNReport &&
                (
                  <Col md={12} className="notificationsType">
                    <p className="notificationSubType1"></p>
                    <p className="notificationSubType2">
                      <Link
                        className="linkStyle"
                        style={{
                          textDecoration: "none",
                          color: "#1395c5",
                        }}
                        to={dvnLinkDetails}
                      >
                        DVN Activity Report
                      </Link>
                    </p>
                  </Col>
                )}
            </Row>
          </Col>
          {this.state.userRole !== Constants.ROLE_MTO_MEMBER && (
            <Col md={6} className="bg-light-withrightborder">
              <Row className="titleStyle">{Constants.MY_APPLICATION}</Row>
              <Row className="m-top-6">
                <GlobalLinks links={this.state.myApplication}></GlobalLinks>
              </Row>
              {this.state.isShippingLocationExist && 
              <Row className="m-top-6">
                <ul>
                  <li>
                    <a
                      href={vspAppLink}
                      target="_blank"
                      className="linkStyle"
                    >
                      {Constants.VSP_LINK_NAME}
                    </a>
                  </li>
                </ul>
              </Row>
              }
              {routingRequestPermission && (
              <Row className="m-top-6">
                <ul>
                  <li>
                    <a
                      href={routingUrl}
                      target="_blank"
                      className="linkStyle"
                    >
                      {Constants.VENDORPLATFORM_SUB_HEAD_ROUTING_REQUST_DETAILS}
                    </a>
                  </li>
                </ul>
              </Row> )}
              {/* {getUserRolePermission(
                RolePermissionConstants.VENDORPLATFORM_SELLER_CENTRAL_REPORTS,
                RolePermissionConstants.ALL
              ) === RolePermissionConstants.EDIT &&
                this.state.sellerCentral === Constants.ENABLED_FLAG && (
                  <Row className="m-top-6">
                    <GlobalLinks links={this.state.sellerHub}></GlobalLinks>
                  </Row>
                )} */}
            </Col>
          )}
          {/*<Col md={3} className="bg-light-withrightborder">
            <Row className="titleStyle">{Constants.COM_NEWS}</Row>
            <Row></Row>
          </Col>
          <Col md={3} className="bg-light-withrightborder">
            <Row className="titleStyle">{Constants.RESOURCES}</Row>
            <Row>
              {this.state.resourceList &&
                this.state.resourceList.length > 0 &&
                this.state.resourceList.map((item) => {
                  return (
                    <div
                      key={item.notificationId}
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        marginBottom: "15px",
                        textAlign: "center",
                        maxWidth: "100%",
                        minWidth: "100%",
                      }}
                    >
                      <div
                        style={{
                          maxWidth: "30%",
                          minWidth: "30%",
                          overflowWrap: "break-word",
                        }}
                      >
                        {item.createdDate}
                      </div>
                      <div
                        style={{
                          maxWidth: "40%",
                          minWidth: "40%",
                          overflowWrap: "break-word",
                        }}
                      >
                        {item.notificationMessage}
                      </div>
                      <div
                        style={{
                          maxWidth: "30%",
                          minWidth: "30%",
                          overflowWrap: "break-word",
                          marginTop: "5px",
                        }}
                      >
                        {this.getDocumentUrl(item)}
                      </div>
                    </div>
                  );
                })}
            </Row>
            {getUserRolePermission(
              RolePermissionConstants.VENDORPLATFORM_MACYHOME_ALLRESOURCES,
              RolePermissionConstants.ALL
            ) !== RolePermissionConstants.NONE && (
              <Row className="m-top-6">
                <GlobalLinks links={this.state.allResource}></GlobalLinks>
              </Row>
            )}
            </Col>*/}
        </Row>
      );
    }
    return null;
  }
}
const mapStateToProps = ({ common }) => ({
  status: common.boardingStatuses,
  configValues: common.configValues,
});

export default connect(mapStateToProps, null)(GlobalHome);
